<template>
  <transition name="modal">
    <div class="modal-mask" data-class="work">
      <div class="modal-wrapper">
        <div class="modal-container app-modal-progress-bar-container">
          <div class="modal-body" style="padding-bottom: 0px !important;">
            <transition name="slide-fade">
              <div
                style="display: flex; align-items: center; justify-content: center;"
                v-if="state === 'loaded'"
              >
                <img
                  src="../../../assets/icons/icon-check.svg"
                  alt="Check"
                  width="52px"
                />
              </div>

              <div
                style="display: flex; align-items: center; justify-content: center;"
                v-if="state === 'error'"
              >
                <img
                  src="../../../assets/icons/icon-wrong.svg"
                  alt="Error"
                  width="52px"
                />
              </div>
            </transition>
            <app-progress-bar
              v-if="state === 'loading'"
              :progress="progress"
              @on-app-progress-bar-completed="handleProgressBarCompleted"
            ></app-progress-bar>
            <p
              style="margin-bottom: 0px; margin-top: 12px; text-align: center;"
            >
              {{ label }}
            </p>
            <div
              v-if="onCancel"
              class="d-flex align-items-center justify-content-center"
              style="margin-top: 20px;"
            >
              <button style="color: red;" @click="onCancel">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import AppProgressBar from './AppProgressBar.vue';
export default {
  props: {
    progress: Number,
    label: String,
    state: {
      type: String,
      default: 'loading', // loading, loaded, error
    },
    onCancel: {
      type: Function,
      default: null,
    },
  },
  components: {
    AppProgressBar,
  },
  methods: {
    handleProgressBarCompleted() {
      this.$emit('on-app-modal-progress-bar-completed');
      setTimeout(() => {
        this.state = 'loaded';
      }, 500);
    },
  },
};
</script>

<style>
.app-modal-progress-bar-container {
  width: 300px !important;
  padding: 16px !important;
}
</style>
